import ProxyTree, { Tree } from './Tree';
import TreeNode from './TreeNode';
Tree.TreeNode = TreeNode;
ProxyTree.TreeNode = TreeNode;

export { Tree, TreeNode };
export default ProxyTree;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-tree/src/index.js
// module id = 907
// module chunks = 0